import { atom } from 'jotai';

export const isEvidenceReferralModalOpenAtom = atom(false);
